import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import axios from "axios";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

const CompanyMasterCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();


    const [errors, setErrors] = useState({});  // ← ADD THIS LINE

    const companyId = location?.state?.companyId;
    const isEdit = location?.state?.isEdit;

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        organizationName: "",
        gstNumber: "",
        email: "",
        alternateEmail: "",
        mobileNumber: "",
        alternateMobileNumber: "",
        gstType: "",
        partyType: "",
        active: true,
        address: {
            landMark: "",
            streetLine1: "",
            streetLine2: "",
            city: "",
            state: "",
            postalCode: "",
            country: "",
            metadata: "",
            primaryAddress: true,
        },
    });

    // Add this entire function
    const validateForm = () => {
        const newErrors = {};

        // First Name Validation
        if (!formData.firstName.trim()) {
            newErrors.firstName = "First Name is required";
        }

        // Last Name Validation
        if (!formData.lastName.trim()) {
            newErrors.lastName = "Last Name is required";
        }

        // GST Type Validation
        if (!formData.gstType) {
            newErrors.gstType = "GST Type is required";
        }

        // Party Type Validation
        if (!formData.partyType) {
            newErrors.partyType = "Party Type is required";
        }
        // Landmark Validation
        if (!formData.address.landMark.trim()) {
            newErrors.landMark = "Landmark is required";
        }
        // Country Validation
        if (!formData.address.country.trim()) {
            newErrors.country = "Country is required";
        }

        // Organization Name Validation
        if (!formData.organizationName.trim()) {
            newErrors.organizationName = "Organization Name is required";
        }

        // GST Number Validation - Standard GSTIN format (with trim) - REQUIRED
        if (!formData.gstNumber || formData.gstNumber.trim() === "") {
            newErrors.gstNumber = "GST Number is required";
        } else {
            const trimmedGST = formData.gstNumber.trim();
            if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[0-9A-Z]{1}$/.test(trimmedGST)) {
                newErrors.gstNumber = "Invalid GST Number. Format";
            }
        }

        // Email Validation
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }

        // Alternate Email Validation
        if (formData.alternateEmail && !/^\S+@\S+\.\S+$/.test(formData.alternateEmail)) {
            newErrors.alternateEmail = "Invalid email format";
        }

        // Mobile Number Validation
        if (!formData.mobileNumber.trim()) {
            newErrors.mobileNumber = "Mobile Number is required";
        } else if (!/^[0-9]{10}$/.test(formData.mobileNumber)) {
            newErrors.mobileNumber = "Mobile Number must be 10 digits";
        }

        // Alternate Mobile Number Validation
        if (formData.alternateMobileNumber && !/^[0-9]{10}$/.test(formData.alternateMobileNumber)) {
            newErrors.alternateMobileNumber = "Mobile Number must be 10 digits";
        }

        // Address Validations
        if (!formData.address.streetLine1.trim()) {
            newErrors.streetLine1 = "Street Line 1 is required";
        }
        if (!formData.address.city.trim()) {
            newErrors.city = "City is required";
        }
        if (!formData.address.state.trim()) {
            newErrors.state = "State is required";
        }
        if (!formData.address.postalCode.trim()) {
            newErrors.postalCode = "Postal Code is required";
        } else if (!/^[0-9]{6}$/.test(formData.address.postalCode)) {
            newErrors.postalCode = "Postal Code must be 6 digits";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ================= INPUT CHANGE =================
    /*
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
    };
*/
    const handleChange = (e) => {
        const { name, value } = e.target;

        let updatedErrors = { ...errors };

        // ================= FIRST NAME =================
        if (name === "firstName") {
            if (!value.trim()) {
                updatedErrors.firstName = "First Name is required";
            } else {
                delete updatedErrors.firstName;
            }
        }

        // ================= LAST NAME =================
        if (name === "lastName") {
            if (!value.trim()) {
                updatedErrors.lastName = "Last Name is required";
            } else {
                delete updatedErrors.lastName;
            }
        }

        // ================= ORGANIZATION NAME =================
        if (name === "organizationName") {
            if (!value.trim()) {
                updatedErrors.organizationName =
                    "Organization Name is required";
            } else {
                delete updatedErrors.organizationName;
            }
        }

        // ================= GST NUMBER =================
        if (name === "gstNumber") {
            const gstRegex =
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[0-9A-Z]{1}$/;

            if (!value.trim()) {
                updatedErrors.gstNumber =
                    "GST Number is required";
            } else if (!gstRegex.test(value.trim().toUpperCase())) {
                updatedErrors.gstNumber =
                    "Invalid GST Number format";
            } else {
                delete updatedErrors.gstNumber;
            }
        }

        // ================= EMAIL =================
        if (name === "email") {
            if (!value.trim()) {
                updatedErrors.email = "Email is required";
            } else if (!/^\S+@\S+\.\S+$/.test(value)) {
                updatedErrors.email =
                    "Invalid email format";
            } else {
                delete updatedErrors.email;
            }
        }

        // ================= ALTERNATE EMAIL =================
        if (name === "alternateEmail") {
            if (!value.trim()) {
                updatedErrors.alternateEmail = "Email is required";
            } else if (!/^\S+@\S+\.\S+$/.test(value)) {
                updatedErrors.alternateEmail =
                    "Invalid email format";
            } else {
                delete updatedErrors.alternateEmail;
            }
        }



        // ================= MOBILE NUMBER =================
        if (
            name === "mobileNumber" ||
            name === "alternateMobileNumber"
        ) {

            // Allow only digits
            if (!/^\d*$/.test(value)) {
                return;
            }

            // Restrict to 10 digits
            if (value.length > 10) {
                return;
            }

            if (name === "mobileNumber") {
                if (!value.trim()) {
                    updatedErrors.mobileNumber =
                        "Mobile Number is required";
                } else if (!/^\d{10}$/.test(value)) {
                    updatedErrors.mobileNumber =
                        "Mobile Number must be 10 digits";
                } else {
                    delete updatedErrors.mobileNumber;
                }
            }

            if (name === "alternateMobileNumber") {
                if (!value.trim()) {
                    updatedErrors.alternateMobileNumber =
                        "Mobile Number is required";
                } else if (!/^\d{10}$/.test(value)) {
                    updatedErrors.alternateMobileNumber =
                        "Alternate  Mobile Number must be 10 digits";
                } else {
                    delete updatedErrors.alternateMobileNumber;
                }
            }


        }

        // ================= GST TYPE =================
        if (name === "gstType") {
            if (!value) {
                updatedErrors.gstType =
                    "GST Type is required";
            } else {
                delete updatedErrors.gstType;
            }
        }

        // ================= PARTY TYPE =================
        if (name === "partyType") {
            if (!value) {
                updatedErrors.partyType =
                    "Party Type is required";
            } else {
                delete updatedErrors.partyType;
            }
        }

        setErrors(updatedErrors);

        setFormData((prev) => ({
            ...prev,
            [name]:
                name === "gstNumber"
                    ? value.toUpperCase()
                    : value,
        }));
    };
    // ================= ADDRESS CHANGE =================
    const handleAddressChange = (e) => {
        const { name, value } = e.target;

        let updatedErrors = { ...errors };

        const requiredFields = [
            "landMark",
            "streetLine1",
            "city",
            "state",
            "country",
        ];

        if (requiredFields.includes(name)) {
            if (!value.trim()) {
                updatedErrors[name] =
                    `${name
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, str => str.toUpperCase())} is required`;
            } else {
                delete updatedErrors[name];
            }
        }

        // Postal Code Validation
        if (name === "postalCode") {
            if (!value.trim()) {
                updatedErrors.postalCode =
                    "Postal Code is required";
            } else if (!/^\d{6}$/.test(value)) {
                updatedErrors.postalCode =
                    "Postal Code must be 6 digits";
            } else {
                delete updatedErrors.postalCode;
            }
        }

        setErrors(updatedErrors);

        setFormData((prev) => ({
            ...prev,
            address: {
                ...prev.address,
                [name]: value,
            },
        }));
    };

    const fetchCompanyById = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/trading-partner/${companyId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = response.data;

            setFormData({
                firstName: data.firstName || "",
                middleName: data.middleName || "",
                lastName: data.lastName || "",
                organizationName: data.organizationName || "",
                gstNumber: data.gstNumber || "",
                email: data.email || "",
                alternateEmail: data.alternateEmail || "",
                mobileNumber: data.mobileNumber || "",
                alternateMobileNumber:
                    data.alternateMobileNumber || "",
                gstType: data.gstType || "INTER_STATE",
                partyType: data.partyType || "",
                active:
                    data.active !== undefined
                        ? data.active
                        : true,

                address: {
                    landMark:
                        data.address?.landMark || "",
                    streetLine1:
                        data.address?.streetLine1 || "",
                    streetLine2:
                        data.address?.streetLine2 || "",
                    city: data.address?.city || "",
                    state: data.address?.state || "",
                    postalCode:
                        data.address?.postalCode || "",
                    country:
                        data.address?.country || "India",
                    metadata:
                        data.address?.metadata || "",
                    primaryAddress:
                        data.address?.primaryAddress ??
                        true,
                },
            });
        } catch (error) {
            console.error(error);
            toast.error("Failed To Fetch Company");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isEdit && companyId) {
            fetchCompanyById();
        }
    }, [companyId, isEdit]);

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();

        // ADD THIS VALIDATION CHECK
        if (!validateForm()) {
            toast.error("Please fill all required fields correctly");
            return;
        }

        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            if (isEdit) {
                await axios.patch(
                    `${process.env.REACT_APP_BACKEND_URL}/trading-partner/${companyId}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":
                                "application/json",
                        },
                    }
                );

                toast.success(
                    "Company Updated Successfully"
                );
            } else {
                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/trading-partner`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type":
                                "application/json",
                        },
                    }
                );

                toast.success(
                    "Company Created Successfully"
                );
            }

            navigate("/company-maslist");
        } catch (error) {
            console.error(error);
            toast.error(
                isEdit
                    ? "Failed To Update Company"
                    : "Failed To Create Company"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="backgound-main-content p-4">
                <div className="container-fluid">

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="fw-bold mb-0">
                            {isEdit ? "Update Company" : "Create Company"}
                        </h3>
                    </div>

                    <form onSubmit={handleSubmit}>

                        {/* Basic Information */}
                        <div className="bg-white rounded  p-4 mb-4">

                            <h5 className="fw-bold mb-3">
                                Basic Information
                            </h5>

                            <div className="row g-3">

                                <div className="col-md-4">
                                    <label className="form-label">
                                        First Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                    />
                                    {errors.firstName && (
                                        <div className="invalid-feedback">{errors.firstName}</div>
                                    )}
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Middle Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="middleName"
                                        value={formData.middleName}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Last Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />
                                    {errors.lastName && (
                                        <div className="invalid-feedback">{errors.lastName}</div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Organization Name<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.organizationName ? 'is-invalid' : ''}`}
                                        name="organizationName"
                                        value={formData.organizationName}
                                        onChange={handleChange}
                                    />
                                    {errors.organizationName && (
                                        < div className="invalid-feedback">{errors.organizationName}</div>)}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        GST Number<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.gstNumber ? 'is-invalid' : ''}`}
                                        name="gstNumber"
                                        value={formData.gstNumber}
                                        onChange={handleChange}
                                    />
                                    {errors.gstNumber && (
                                        < div className="invalid-feedback">{errors.gstNumber}</div>
                                    )}
                                </div>

                            </div>

                        </div>

                        {/* Contact Details */}
                        <div className="bg-white rounded  p-4 mb-4">

                            <h5 className="fw-bold mb-3">
                                Contact Details
                            </h5>

                            <div className="row g-3">

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Email<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                    {errors.email && (
                                        < div className="invalid-feedback">{errors.email}</div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Alternate Email
                                    </label>
                                    <input
                                        type="email"

                                        className={`form-control ${errors.alternateEmail ? 'is-invalid' : ''}`}
                                        name="alternateEmail"
                                        value={formData.alternateEmail}
                                        onChange={handleChange}
                                    />
                                    {errors.alternateEmail && (
                                        < div className="invalid-feedback">{errors.alternateEmail}</div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Mobile Number<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.mobileNumber ? 'is-invalid' : ''}`}
                                        name="mobileNumber"
                                        value={formData.mobileNumber}
                                        onChange={handleChange}
                                        maxLength={10}
                                    />
                                    {errors.mobileNumber && (
                                        < div className="invalid-feedback">{errors.mobileNumber}</div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Alternate Mobile Number
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.alternateMobileNumber ? "is-invalid" : ""
                                            }`}
                                        name="alternateMobileNumber"
                                        value={formData.alternateMobileNumber}
                                        onChange={handleChange}
                                        maxLength={10}
                                    />

                                    {errors.alternateMobileNumber && (
                                        <div className="invalid-feedback">
                                            {errors.alternateMobileNumber}
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        GST Type<span className="text-danger">*</span>
                                    </label>

                                    <select
                                        className={`form-select ${errors.gstType ? 'is-invalid' : ''}`}
                                        name="gstType"
                                        value={formData.gstType}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select GST Type</option>
                                        <option value="INTER_STATE">
                                            INTER STATE
                                        </option>

                                        <option value="INTRA_STATE">
                                            INTRA STATE
                                        </option>
                                    </select>
                                    {errors.gstType && (
                                        <div className="invalid-feedback">{errors.gstType}</div>
                                    )}
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        PartyType<span className="text-danger">*</span>
                                    </label>

                                    <select
                                        className={`form-select ${errors.partyType ? 'is-invalid' : ''}`}
                                        name="partyType"
                                        value={formData.partyType}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Party Type</option>
                                        <option value="CUSTOMER">
                                            CUSTOMER
                                        </option>

                                        <option value="VENDOR">
                                            VENDOR
                                        </option>
                                    </select>
                                    {errors.partyType && (
                                        <div className="invalid-feedback">{errors.partyType}</div>
                                    )}
                                </div>

                            </div>

                        </div>

                        {/* Address Details */}
                        <div className="bg-white rounded  p-4 mb-4">

                            <h5 className="fw-bold mb-3">
                                Address Details
                            </h5>

                            <div className="row g-3">

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Landmark<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.landMark ? 'is-invalid' : ''}`}
                                        name="landMark"
                                        value={formData.address.landMark}
                                        onChange={handleAddressChange}
                                    />
                                    {errors.landMark && (
                                        <div className="invalid-feedback">{errors.landMark}</div>
                                    )}
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Street Line 1<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.streetLine1 ? 'is-invalid' : ''}`}
                                        name="streetLine1"
                                        value={formData.address.streetLine1}
                                        onChange={handleAddressChange}
                                    />
                                    {errors.streetLine1 && (
                                        < div className="invalid-feedback">{errors.streetLine1}</div>
                                    )}
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">
                                        Street Line 2
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="streetLine2"
                                        value={formData.address.streetLine2}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        City <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                                        name="city"
                                        value={formData.address.city}
                                        onChange={handleAddressChange}
                                    />
                                    {errors.city && (
                                        <div className="invalid-feedback">{errors.city}</div>
                                    )}
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        State<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                                        name="state"
                                        value={formData.address.state}
                                        onChange={handleAddressChange}
                                    />
                                    {errors.state && (
                                        < div className="invalid-feedback">{errors.state}</div>
                                    )}
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        Postal Code<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.postalCode ? 'is-invalid' : ''}`}
                                        name="postalCode"
                                        value={formData.address.postalCode}
                                        onChange={handleAddressChange}
                                    />
                                    {errors.postalCode && (
                                        < div className="invalid-feedback">{errors.postalCode}</div>
                                    )}
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">
                                        Country<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${errors.country ? 'is-invalid' : ''}`}
                                        name="country"
                                        value={formData.address.country}
                                        onChange={handleAddressChange}
                                    />
                                    {errors.country && (
                                        <div className="invalid-feedback">{errors.country}</div>
                                    )}
                                </div>

                                <div className="col-12">
                                    <label className="form-label">
                                        Metadata
                                    </label>

                                    <textarea
                                        className="form-control"
                                        rows="4"
                                        name="metadata"
                                        value={formData.address.metadata}
                                        onChange={handleAddressChange}
                                    />
                                </div>

                            </div>

                        </div>

                        {/* Buttons */}
                        <div className="d-flex justify-content-end gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() =>
                                    navigate("/company-maslist")
                                }
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? isEdit
                                        ? "Updating..."
                                        : "Saving..."
                                    : isEdit
                                        ? "Update Company"
                                        : "Save Company"}
                            </button>

                        </div>

                    </form>

                </div>
            </div >
        </Layout >
    );
};

export default CompanyMasterCreate;